import config from '../../config/config';

export const BOARDING_STATUS_SUMMARY_FAILURE = 'BOARDING_STATUS_SUMMARY/BOARDING_STATUS_SUMMARY_FAILURE';
export const BOARDING_STATUS_SUMMARY_LOAD = 'BOARDING_STATUS_SUMMARY/BOARDING_STATUS_SUMMARY_LOAD';
export const BOARDING_STATUS_SUMMARY_SUCCESS = 'BOARDING_STATUS_SUMMARY/BOARDING_STATUS_SUMMARY_SUCCESS';

export function getBoardingStatusSummary(silent = false) {
    return {
        failureActionTypeOrCreator: getBoardingStatusSummaryFailureActionCreator,
        fetchParams: {
            url: `${config.underwritingApiUrl}/onboarding/reports/statusSummary`
        },
        loadActionTypeOrCreator: silent ? null : BOARDING_STATUS_SUMMARY_LOAD,
        successActionTypeOrCreator: getBoardingStatusSummarySuccessActionCreator
    };
}

export function getBoardingStatusSummaryLegacy() {
    return {
        failureActionTypeOrCreator: getBoardingStatusSummaryFailureActionCreator,
        fetchParams: {
            url: `${config.processorOnboardingApiUrl}/statusSummary`
        },
        loadActionTypeOrCreator: BOARDING_STATUS_SUMMARY_LOAD,
        successActionTypeOrCreator: getBoardingStatusSummarySuccessActionCreator
    };
}

export function getBoardingStatusSummaryFailureActionCreator(error) {
    return {
        error,
        type: BOARDING_STATUS_SUMMARY_FAILURE
    };
}

export function getBoardingStatusSummarySuccessActionCreator(boardingStatusSummary) {
    return {
        boardingStatusSummary,
        type: BOARDING_STATUS_SUMMARY_SUCCESS
    };
}
